// Source: https://github.com/ain/smartbanner.js/blob/main/src/detector.js
export function getUserAgentPlatform() {
  const maxTouchPoints = window.navigator.maxTouchPoints
  const userAgent = window.navigator.userAgent

  if (/Android/i.test(userAgent)) {
    return 'android'
  } else if (
    // @ts-expect-error -- MSSstream is not defined in the window object
    (!window.MSStream && !/X11|Linux|Windows/i.test(userAgent) && maxTouchPoints && maxTouchPoints > 0) ||
    /iPhone|iPad|iPod/i.test(userAgent)
  ) {
    return 'ios'
  }
}
